import { Injectable } from '@angular/core';
import { asyncScheduler, defer, Observable, of, scheduled } from 'rxjs';

const E2E_UNAUTH_KEY = 'e2e_unauth';
const E2E_NO_RIGHTS_KEY = 'e2e_no_rights';

function readAuthenticated(): boolean {
  try {
    return window.localStorage.getItem(E2E_UNAUTH_KEY) !== '1';
  } catch {
    return true;
  }
}

function readHasRights(): boolean {
  try {
    return window.localStorage.getItem(E2E_NO_RIGHTS_KEY) !== '1';
  } catch {
    return true;
  }
}

@Injectable({ providedIn: 'root' })
export class MockAuthService {
  // Use asyncScheduler so the emission happens after all NgRx effects have
  // subscribed. A synchronous emit would race with TrashEffects / CurrentSelectionEffects
  // (which come after InitEffects in platformEffects) and cause those actions to be missed.
  readonly isAuthenticated$: Observable<boolean> = defer(() =>
    scheduled(of(readAuthenticated()), asyncScheduler),
  );
  readonly isLoading$: Observable<boolean> = of(false);
  readonly error$: Observable<Error | null> = of(null);
  readonly user$: Observable<Record<string, unknown> | null> = defer(() =>
    of(
      readAuthenticated()
        ? { sub: 'e2e|user', name: 'E2E User', email: 'e2e@test.local' }
        : null,
    ),
  );
  readonly idTokenClaims$: Observable<Record<string, unknown>> = defer(() =>
    of({ hasRights: readHasRights() }),
  );

  getAccessTokenSilently(): Observable<string> {
    return of('e2e-access-token');
  }

  loginWithRedirect(): Promise<void> {
    return Promise.resolve();
  }

  logout(): Promise<void> {
    return Promise.resolve();
  }

  handleRedirectCallback(): Observable<unknown> {
    return of(null);
  }
}
